// function updateProgressSlider() {
//   document.addEventListener("DOMContentLoaded", () => {
//     const t = document.querySelector(".product_slider_new_anarc"),
//       e = document.getElementById("progress-bar-new-anarc-pdp"),
//       i = document.getElementById("tabs-bar"),
//       n = document.getElementById("designed_to_be_different"),
//       a = document.querySelectorAll(".thumbnail");
//     if (!(t && e && i && n)) return;
//     const r = t.querySelectorAll(".product__media-item").length;
//     let s = 0;
//     const o = e.parentElement;
//     (o.classList.add("progress-container"), e.classList.add("progress-bar"));
//     const l = (t) => {
//       const i = o.offsetWidth,
//         n = i / r,
//         a = (t / (r - 1)) * (i - n);
//       ((e.style.width = `${n}px`), (e.style.left = `${a}px`));
//     };
//     l(s);
//     let c = !1;
//     if (
//       (t.addEventListener("scroll", () => {
//         c ||
//           (window.requestAnimationFrame(() => {
//             ((() => {
//               const e = Math.round(t.scrollLeft / t.clientWidth);
//               e !== s && ((s = e), l(s));
//             })(),
//               (c = !1));
//           }),
//           (c = !0));
//       }),
//       a.forEach((e, i) => {
//         e.addEventListener("click", () => {
//           s = i;
//           t.clientWidth;
//           (t.scrollTo({ left: desiredScrollLeft, behavior: "smooth" }), l(s));
//         });
//       }),
//       window.addEventListener("resize", () => l(s)),
//       window.innerWidth > 768)
//     ) {
//       const t = n.offsetTop;
//       window.addEventListener("scroll", () => {
//         const e = window.scrollY;
//         i.classList.toggle("hidden", e >= t);
//       });
//     }
//   });
// }
// function updateWhatInTheBoxImage(t) {
//   const e = document.querySelector(".main_container_image_wrapper");
//   e &&
//     fetch(
//       `${window.location.pathname}?variant=${t}&section_id=variant-what-in-the-box-section`,
//     )
//       .then((t) => t.text())
//       .then((t) => {
//         const i = new DOMParser()
//           .parseFromString(t, "text/html")
//           .querySelector(".main_container_image_wrapper");
//         e.innerHTML = i.innerHTML;
//       });
// }
// customElements.get("product-info") ||
//   customElements.define(
//     "product-info",
//     class extends HTMLElement {
//       quantityInput = void 0;
//       quantityForm = void 0;
//       onVariantChangeUnsubscriber = void 0;
//       cartUpdateUnsubscriber = void 0;
//       abortController = void 0;
//       pendingRequestUrl = null;
//       preProcessHtmlCallbacks = [];
//       postProcessHtmlCallbacks = [];
//       constructor() {
//         (super(),
//           (this.quantityInput = this.querySelector(".quantity__input")));
//       }
//       connectedCallback() {
//         (this.initializeProductSwapUtility(),
//           (this.onVariantChangeUnsubscriber = subscribe(
//             PUB_SUB_EVENTS.optionValueSelectionChange,
//             this.handleOptionValueChange.bind(this),
//           )),
//           this.initQuantityHandlers(),
//           this.dispatchEvent(
//             new CustomEvent("product-info:loaded", { bubbles: !0 }),
//           ));
//       }
//       addPreProcessCallback(t) {
//         this.preProcessHtmlCallbacks.push(t);
//       }
//       initQuantityHandlers() {
//         this.quantityInput &&
//           ((this.quantityForm = this.querySelector(".product-form__quantity")),
//           this.quantityForm &&
//             (this.setQuantityBoundries(),
//             this.dataset.originalSection ||
//               (this.cartUpdateUnsubscriber = subscribe(
//                 PUB_SUB_EVENTS.cartUpdate,
//                 this.fetchQuantityRules.bind(this),
//               ))));
//       }
//       disconnectedCallback() {
//         (this.onVariantChangeUnsubscriber(), this.cartUpdateUnsubscriber?.());
//       }
//       initializeProductSwapUtility() {
//         (this.preProcessHtmlCallbacks.push((t) =>
//           t
//             .querySelectorAll(".scroll-trigger")
//             .forEach((t) => t.classList.add("scroll-trigger--cancel")),
//         ),
//           this.postProcessHtmlCallbacks.push((t) => {
//             (window?.Shopify?.PaymentButton?.init(),
//               window?.ProductModel?.loadShopifyXR());
//           }));
//       }
//       async handleOptionValueChange({
//         data: { event: t, target: e, selectedOptionValues: i },
//       }) {
//         if (!this.contains(t.target)) return;
//         const n = e
//           .closest("fieldset")
//           .querySelector(`label[for="${e.getAttribute("id")}"]`)
//           .getAttribute("cstmvarint-id");
//         this.resetProductFormState();
//         const a = new URLSearchParams(window.location.search).get("view"),
//           r =
//             e.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
//         this.pendingRequestUrl = r;
//         const s = this.dataset.url !== r,
//           o = "true" === this.dataset.updateUrl && s,
//           l = null !== a ? `${r}?view=${a}` : r;
//         this.renderProductInfo({
//           requestUrl: this.buildRequestUrlWithParams(l, i, o, n),
//           targetId: e.id,
//           callback: s
//             ? this.handleSwapProduct(r, o, l)
//             : this.handleUpdateProductInfo(r, l),
//         });
//       }
//       resetProductFormState() {
//         const t = this.productForm;
//         (t?.toggleSubmitButton(!0), t?.handleErrorMessage());
//       }
//       handleSwapProduct(t, e, i = "") {
//         return (i) => {
//           this.productModal?.remove();
//           const n = e ? "product-info[id^='MainProduct']" : "product-info",
//             a = this.getSelectedVariant(i.querySelector(n));
//           (this.updateURL(t, a?.id),
//             e
//               ? ((document.querySelector("head title").innerHTML =
//                   i.querySelector("head title").innerHTML),
//                 HTMLUpdateUtility.viewTransition(
//                   document.querySelector("main"),
//                   i.querySelector("main"),
//                   this.preProcessHtmlCallbacks,
//                   this.postProcessHtmlCallbacks,
//                 ))
//               : HTMLUpdateUtility.viewTransition(
//                   this,
//                   i.querySelector("product-info"),
//                   this.preProcessHtmlCallbacks,
//                   this.postProcessHtmlCallbacks,
//                 ));
//         };
//       }
//       renderProductInfo({ requestUrl: t, targetId: e, callback: i }) {
//         (this.abortController?.abort(),
//           (this.abortController = new AbortController()),
//           fetch(t, { signal: this.abortController.signal })
//             .then((t) => t.text())
//             .then((e) => {
//               this.pendingRequestUrl = null;
//               const n = new DOMParser().parseFromString(e, "text/html"),
//                 a = document.querySelector(
//                   ".container__sticky_atc .right-side-container",
//                 ),
//                 r = document.querySelector(
//                   ".container__sticky_atc .bottom-part",
//                 ),
//                 s = n.querySelector(
//                   ".container__sticky_atc .right-side-container",
//                 ),
//                 o = n.querySelector(".container__sticky_atc .bottom-part");
//               (s && (a.innerHTML = s.innerHTML),
//                 o && (r.innerHTML = o.innerHTML),
//                 i(n, t));
//             })
//             .then(() => {
//               document.querySelector(`#${e}`)?.focus();
//               const t = document.querySelector(`#${e}`),
//                 i = document.querySelector("#sticky-variant-name");
//               i && (i.innerText = t.value);
//               "anarc-new-pdp" ==
//                 new URLSearchParams(window.location.search).get("view") &&
//                 document
//                   .querySelectorAll("#MainContent video")
//                   .forEach((t) => t.load());
//               updateWhatInTheBoxImage(
//                 document.querySelector(`#${e}`).dataset.varaintId,
//               );
//             })
//             .catch((t) => {
//               "AbortError" === t.name
//                 ? console.log("Fetch aborted by user")
//                 : console.error(t);
//             }));
//       }
//       getSelectedVariant(t) {
//         const e = t.querySelector(
//           "variant-selects [data-selected-variant]",
//         )?.innerHTML;
//         return e ? JSON.parse(e) : null;
//       }
//       buildRequestUrlWithParams(t, e, i = !1, n) {
//         const a = [];
//         return (
//           !i && a.push(`section_id=${this.sectionId}`),
//           e.length && a.push(`option_values=${e.join(",")}`),
//           a.push(`variant=${n}`),
//           `${t}${t.includes("?") ? `&${a.join("&")}` : `?${a.join("&")}`}`
//         );
//       }
//       updateOptionValues(t) {
//         const e = t.querySelector("variant-selects");
//         e &&
//           HTMLUpdateUtility.viewTransition(
//             this.variantSelectors,
//             e,
//             this.preProcessHtmlCallbacks,
//           );
//       }
//       handleUpdateProductInfo(t, e = "") {
//         return (t) => {
//           const i = this.getSelectedVariant(t);
//           (this.pickupAvailability?.update(i),
//             this.updateOptionValues(t),
//             this.updateURL(e, i?.id),
//             this.updateVariantInputs(i?.id));
//           const n = this.updatedURL(e, i?.id);
//           if (!i) return void this.setUnavailable();
//           this.updateMedia(t, i?.featured_media?.id, n);
//           const a = (e, i = (t) => !1) => {
//             const n = t.getElementById(`${e}-${this.sectionId}`),
//               a = this.querySelector(`#${e}-${this.dataset.section}`);
//             n &&
//               a &&
//               ((a.innerHTML = n.innerHTML), a.classList.toggle("hidden", i(n)));
//           };
//           (a("price"),
//             a("Ship"),
//             a("variant-title"),
//             a("Sku", ({ classList: t }) => t.contains("hidden")),
//             a("Inventory", ({ innerText: t }) => "" === t),
//             a("Volume"),
//             a("Price-Per-Item", ({ classList: t }) => t.contains("hidden")),
//             this.updateQuantityRules(this.sectionId, t),
//             this.querySelector(
//               `#Quantity-Rules-${this.dataset.section}`,
//             )?.classList.remove("hidden"),
//             this.querySelector(
//               `#Volume-Note-${this.dataset.section}`,
//             )?.classList.remove("hidden"),
//             this.productForm?.toggleSubmitButton(
//               t
//                 .getElementById(`ProductSubmitButton-${this.sectionId}`)
//                 ?.hasAttribute("disabled") ?? !0,
//               window.variantStrings.soldOut,
//               i?.id,
//             ),
//             publish(PUB_SUB_EVENTS.variantChange, {
//               data: { sectionId: this.sectionId, html: t, variant: i },
//             }));
//         };
//       }
//       updateVariantInputs(t) {
//         this.querySelectorAll(
//           `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
//         ).forEach((e) => {
//           const i = e.querySelector('input[name="id"]');
//           ((i.value = t ?? ""),
//             i.dispatchEvent(new Event("change", { bubbles: !0 })));
//         });
//       }
//       updateURL(t, e) {
//         new URLSearchParams(window.location.search).has("view");
//         (this.querySelector("share-button")?.updateUrl(
//           `${window.shopUrl}${t}${e ? `?variant=${e}` : ""}`,
//         ),
//           "false" !== this.dataset.updateUrl &&
//             window.history.replaceState(
//               {},
//               "",
//               `${t}${e ? (t.includes("?") ? `&variant=${e}` : `?variant=${e}`) : ""}`,
//             ));
//       }
//       updatedURL(t, e) {
//         new URLSearchParams(window.location.search).has("view");
//         if (
//           (this.querySelector("share-button")?.updateUrl(
//             `${window.shopUrl}${t}${e ? `?variant=${e}` : ""}`,
//           ),
//           "false" !== this.dataset.updateUrl)
//         )
//           return (
//             window.location.origin +
//             `${t}${e ? (t.includes("?") ? `&variant=${e}` : `?variant=${e}`) : ""}`
//           );
//       }
//       setUnavailable() {
//         this.productForm?.toggleSubmitButton(
//           !0,
//           window.variantStrings.unavailable,
//         );
//         const t = [
//           "price",
//           "Inventory",
//           "Sku",
//           "Price-Per-Item",
//           "Volume-Note",
//           "Volume",
//           "Quantity-Rules",
//         ]
//           .map((t) => `#${t}-${this.dataset.section}`)
//           .join(", ");
//         document
//           .querySelectorAll(t)
//           .forEach(({ classList: t }) => t.add("hidden"));
//       }
//       updateMedia(t, e, i = "") {
//         if (!e) return;
//         const n = new URL(i).searchParams.get("view"),
//           a = this.querySelector("media-gallery ul"),
//           r = t.querySelector("media-gallery ul"),
//           s = this.querySelector("media-gallery .thumbnail-slider ul"),
//           o = t.querySelector("media-gallery .thumbnail-slider ul"),
//           l = () => {
//             this.hasAttribute("data-zoom-on-hover") && enableZoomOnHover(2);
//             const t = Array.from(a.querySelectorAll("li[data-media-id]")),
//               e = new Set(t.map((t) => t.dataset.mediaId)),
//               i = new Map(
//                 t.map((t, e) => [t.dataset.mediaId, { item: t, index: e }]),
//               );
//             return [t, e, i];
//           };
//         if (a && r) {
//           let [t, e, i] = l();
//           const n = Array.from(r.querySelectorAll("li[data-media-id]")),
//             s = new Set(n.map(({ dataset: t }) => t.mediaId));
//           let o = !1;
//           for (let t = n.length - 1; t >= 0; t--)
//             e.has(n[t].dataset.mediaId) || (a.prepend(n[t]), (o = !0));
//           for (let e = 0; e < t.length; e++)
//             s.has(t[e].dataset.mediaId) || (t[e].remove(), (o = !0));
//           (o && ([t, e, i] = l()),
//             n.forEach((n, r) => {
//               const s = i.get(n.dataset.mediaId);
//               s &&
//                 s.index !== r &&
//                 (a.insertBefore(
//                   s.item,
//                   a.querySelector(`li:nth-of-type(${r + 1})`),
//                 ),
//                 ([t, e, i] = l()));
//             }));
//         }
//         this.querySelector("media-gallery")?.setActiveMedia?.(
//           `${this.dataset.section}-${e}`,
//           !0,
//         );
//         const c = this.productModal?.querySelector(
//             ".product-media-modal__content",
//           ),
//           d = t.querySelector("product-modal .product-media-modal__content");
//         (c && d && (c.innerHTML = d.innerHTML),
//           a && r && null === n && (a.innerHTML = r.innerHTML),
//           s && o && (s.innerHTML = o.innerHTML));
//         const u = this.querySelectorAll("slider-component");
//         u.length && u.forEach((t) => t.resetPages());
//         const h = this.querySelector("media-gallery");
//         if (h) {
//           const t = h.querySelector('[id^="GalleryViewer"]'),
//             e = h.querySelector('[id^="GalleryThumbnails"]');
//           t &&
//             e &&
//             (t.addEventListener(
//               "slideChanged",
//               debounce(h.onSlideChanged.bind(h), 500),
//             ),
//             e.querySelectorAll("[data-target]").forEach((t) => {
//               t.querySelector("button").addEventListener(
//                 "click",
//                 h.setActiveMedia.bind(h, t.dataset.target, !1),
//               );
//             }));
//         }
//       }
//       setQuantityBoundries() {
//         const t = {
//           cartQuantity: this.quantityInput.dataset.cartQuantity
//             ? parseInt(this.quantityInput.dataset.cartQuantity)
//             : 0,
//           min: this.quantityInput.dataset.min
//             ? parseInt(this.quantityInput.dataset.min)
//             : 1,
//           max: this.quantityInput.dataset.max
//             ? parseInt(this.quantityInput.dataset.max)
//             : null,
//           step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
//         };
//         let e = t.min;
//         const i = null === t.max ? t.max : t.max - t.cartQuantity;
//         (null !== i && (e = Math.min(e, i)),
//           t.cartQuantity >= t.min && (e = Math.min(e, t.step)),
//           (this.quantityInput.min = e),
//           i
//             ? (this.quantityInput.max = i)
//             : this.quantityInput.removeAttribute("max"),
//           (this.quantityInput.value = e),
//           publish(PUB_SUB_EVENTS.quantityUpdate, void 0));
//       }
//       fetchQuantityRules() {
//         const t = this.productForm?.variantIdInput?.value;
//         t &&
//           (this.querySelector(
//             ".quantity__rules-cart .loading__spinner",
//           ).classList.remove("hidden"),
//           fetch(
//             `${this.dataset.url}?variant=${t}&section_id=${this.dataset.section}`,
//           )
//             .then((t) => t.text())
//             .then((t) => {
//               const e = new DOMParser().parseFromString(t, "text/html");
//               this.updateQuantityRules(this.dataset.section, e);
//             })
//             .catch((t) => console.error(t))
//             .finally(() =>
//               this.querySelector(
//                 ".quantity__rules-cart .loading__spinner",
//               ).classList.add("hidden"),
//             ));
//       }
//       updateQuantityRules(t, e) {
//         if (!this.quantityInput) return;
//         this.setQuantityBoundries();
//         const i = e.getElementById(`Quantity-Form-${t}`),
//           n = [".quantity__input", ".quantity__rules", ".quantity__label"];
//         for (let t of n) {
//           const e = this.quantityForm.querySelector(t),
//             n = i.querySelector(t);
//           if (e && n)
//             if (".quantity__input" === t) {
//               const t = ["data-cart-quantity", "data-min", "data-max", "step"];
//               for (let i of t) {
//                 const t = n.getAttribute(i);
//                 null !== t ? e.setAttribute(i, t) : e.removeAttribute(i);
//               }
//             } else e.innerHTML = n.innerHTML;
//         }
//       }
//       get productForm() {
//         return this.querySelector("product-form");
//       }
//       get productModal() {
//         return document.querySelector(`#ProductModal-${this.dataset.section}`);
//       }
//       get pickupAvailability() {
//         return this.querySelector("pickup-availability");
//       }
//       get variantSelectors() {
//         return this.querySelector("variant-selects");
//       }
//       get relatedProducts() {
//         const t = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           "related-products",
//         );
//         return document.querySelector(
//           `product-recommendations[data-section-id^="${t}"]`,
//         );
//       }
//       get quickOrderList() {
//         const t = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           "quick_order_list",
//         );
//         return document.querySelector(`quick-order-list[data-id^="${t}"]`);
//       }
//       get sectionId() {
//         return this.dataset.originalSection || this.dataset.section;
//       }
//     },
//   );










function updateProgressSlider() {
  document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector(".product_slider_new_anarc");
    const progressBar = document.getElementById("progress-bar-new-anarc-pdp");
    const stickyHeader = document.getElementById("tabs-bar");
    const secondSection = document.getElementById("designed_to_be_different");
    const thumbnails = document.querySelectorAll(".thumbnail");

    if (!(slider && progressBar && stickyHeader && secondSection)) return;

    const totalSlides = slider.querySelectorAll(".product__media-item").length;
    let currentIndex = 0;

    const progressContainer = progressBar.parentElement;
    progressContainer.classList.add("progress-container");
    progressBar.classList.add("progress-bar");

    const updateProgressBar = (index) => {
      const containerWidth = progressContainer.offsetWidth;
      const barWidth = containerWidth / totalSlides;
      const leftOffset = (index / (totalSlides - 1)) * (containerWidth - barWidth);
      progressBar.style.width = `${barWidth}px`;
      progressBar.style.left = `${leftOffset}px`;
    };

    updateProgressBar(currentIndex);

    let scrollTicking = false;
    slider.addEventListener("scroll", () => {
      if (scrollTicking) return;
      window.requestAnimationFrame(() => {
        (() => {
          const newIndex = Math.round(slider.scrollLeft / slider.clientWidth);
          if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            updateProgressBar(currentIndex);
          }
        })();
        scrollTicking = false;
      });
      scrollTicking = true;
    });

    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        currentIndex = index;
        slider.clientWidth; // NOTE: value computed but unused in original (see BUG note below)
        slider.scrollTo({
          left: desiredScrollLeft, // BUG: `desiredScrollLeft` is never defined -> ReferenceError
          behavior: "smooth",
        });
        updateProgressBar(currentIndex);
      });
    });

    window.addEventListener("resize", () => updateProgressBar(currentIndex));

    if (window.innerWidth > 768) {
      const secondOffset = secondSection.offsetTop;
      window.addEventListener("scroll", () => {
        const y = window.scrollY;
        stickyHeader.classList.toggle("hidden", y >= secondOffset);
      });
    }
  });
}

/* ------------------------------------------------------------------ *
 * "What's in the box" image swap on variant change
 * ------------------------------------------------------------------ */
function updateWhatInTheBoxImage(variantId) {
  const wrapper = document.querySelector(".anarc-pdp-accessories");
  if (!wrapper) return;
  const new_url = `${window.location.pathname}?variant=${variantId}&section_id=anarc_product_specification_section`;
  fetch(new_url)
    .then((response) => response.text())
    .then((html) => {
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const newWrapper = parsed.querySelector(".anarc-pdp-accessories");
      wrapper.innerHTML = newWrapper.innerHTML;
    });
}

/* ------------------------------------------------------------------ *
 * <product-info> custom element
 * ------------------------------------------------------------------ */
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      async handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        const customVariantId = target
          .closest("fieldset")
          .querySelector(`label[for="${target.getAttribute("id")}"]`)
          .getAttribute("cstmvarint-id");

        this.resetProductFormState();

        const viewParam = new URLSearchParams(window.location.search).get("view");
        const requestUrl =
          target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = requestUrl;

        const shouldSwapProduct = this.dataset.url !== requestUrl;
        const shouldUpdateUrl =
          this.dataset.updateUrl === "true" && shouldSwapProduct;
        const urlWithView =
          viewParam !== null ? `${requestUrl}?view=${viewParam}` : requestUrl;
          
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            urlWithView,
            selectedOptionValues,
            shouldUpdateUrl,
            customVariantId
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(requestUrl, shouldUpdateUrl, urlWithView)
            : this.handleUpdateProductInfo(requestUrl, urlWithView),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateUrl, urlWithView = "") {
        return (parsedHtml) => {
          this.productModal?.remove();

          const selector = updateUrl
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(
            parsedHtml.querySelector(selector)
          );
          this.updateURL(productUrl, variant?.id);

          if (updateUrl) {
            document.querySelector("head title").innerHTML =
              parsedHtml.querySelector("head title").innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              parsedHtml.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              parsedHtml.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const parsedHtml = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );

            // Update sticky ATC bar pieces
            const rightSide = document.querySelector(
              ".container__sticky_atc .right-side-container"
            );
            const bottomPart = document.querySelector(
              ".container__sticky_atc .bottom-part"
            );
            const newRightSide = parsedHtml.querySelector(
              ".container__sticky_atc .right-side-container"
            );
            const newBottomPart = parsedHtml.querySelector(
              ".container__sticky_atc .bottom-part"
            );
            if (newRightSide) rightSide.innerHTML = newRightSide.innerHTML;
            if (newBottomPart) bottomPart.innerHTML = newBottomPart.innerHTML;

            callback(parsedHtml, requestUrl);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();

            const target = document.querySelector(`#${targetId}`);
            const stickyVariantName = document.querySelector(
              "#sticky-variant-name"
            );
            if (stickyVariantName) stickyVariantName.innerText = target.value;

            if (new URLSearchParams(window.location.search).get("view") === "anarc-new-pdp" || new URLSearchParams(window.location.search).get("view") === "anarc-nexora") {
              document
                .querySelectorAll("#MainContent video")
                .forEach((video) => video.load());
            }

            updateWhatInTheBoxImage(
              document.querySelector(`#${targetId}`).dataset.varaintId
            );
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(html) {
        const selectedVariant = html.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldUpdateUrl = false,
        customVariantId
      ) {
        const params = [];

        if (!shouldUpdateUrl) params.push(`section_id=${this.sectionId}`);
        if (optionValues.length)
          params.push(`option_values=${optionValues.join(",")}`);
        params.push(`variant=${customVariantId}`);

        return `${url}${url.includes("?") ? `&${params.join("&")}` : `?${params.join("&")}`}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl, urlWithView = "") {
        return (parsedHtml) => {
          const variant = this.getSelectedVariant(parsedHtml);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(parsedHtml);
          this.updateURL(urlWithView, variant?.id);
          this.updateVariantInputs(variant?.id);
          console.log('parsedHtml--',parsedHtml);

          const newUrl = this.updatedURL(urlWithView, variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(parsedHtml, variant?.featured_media?.id, newUrl);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = parsedHtml.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Ship");
          updateSourceFromDestination("variant-title");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination("Inventory", ({ innerText }) =>
            innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateQuantityRules(this.sectionId, parsedHtml);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            parsedHtml
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut,
            variant?.id
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html: parsedHtml,
              variant: variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        new URLSearchParams(window.location.search).has("view");
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );
        if (this.dataset.updateUrl !== "false") {
          window.history.replaceState(
            {},
            "",
            `${url}${
              variantId
                ? url.includes("?")
                  ? `&variant=${variantId}`
                  : `?variant=${variantId}`
                : ""
            }`
          );
        }
      }

      updatedURL(url, variantId) {
        new URLSearchParams(window.location.search).has("view");
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );
        if (this.dataset.updateUrl !== "false") {
          return (
            window.location.origin +
            `${url}${
              variantId
                ? url.includes("?")
                  ? `&variant=${variantId}`
                  : `?variant=${variantId}`
                : ""
            }`
          );
        }
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );
        const selector = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document.querySelectorAll(selector).forEach(({ classList }) =>
          classList.add("hidden")
        );
      }

      updateMedia(parsedHtml, mediaId, url = "") {
        if (!mediaId) return;

        const view = new URL(url).searchParams.get("view");
        const currentGalleryList = this.querySelector("media-gallery ul");
        const newGalleryList = parsedHtml.querySelector("media-gallery ul");
        const currentThumbList = this.querySelector(
          "media-gallery .thumbnail-slider ul"
        );
        const newThumbList = parsedHtml.querySelector(
          "media-gallery .thumbnail-slider ul"
        );

        const snapshotCurrentMedia = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const items = Array.from(
            currentGalleryList.querySelectorAll("li[data-media-id]")
          );
          const idSet = new Set(items.map((item) => item.dataset.mediaId));
          const idToItem = new Map(
            items.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [items, idSet, idToItem];
        };

        if (currentGalleryList && newGalleryList) {
          let [currentItems, currentIdSet, currentIdMap] =
            snapshotCurrentMedia();

          const newItems = Array.from(
            newGalleryList.querySelectorAll("li[data-media-id]")
          );
          const newIdSet = new Set(
            newItems.map(({ dataset }) => dataset.mediaId)
          );

          let changed = false;

          // Prepend media that exist in the new list but not the current one
          for (let i = newItems.length - 1; i >= 0; i--) {
            if (!currentIdSet.has(newItems[i].dataset.mediaId)) {
              currentGalleryList.prepend(newItems[i]);
              changed = true;
            }
          }

          // Remove current media that no longer exist in the new list
          for (let i = 0; i < currentItems.length; i++) {
            if (!newIdSet.has(currentItems[i].dataset.mediaId)) {
              currentItems[i].remove();
              changed = true;
            }
          }

          if (changed) {
            [currentItems, currentIdSet, currentIdMap] = snapshotCurrentMedia();
          }

          // Reorder existing media to match the new order
          newItems.forEach((newItem, newIndex) => {
            const existing = currentIdMap.get(newItem.dataset.mediaId);
            if (existing && existing.index !== newIndex) {
              currentGalleryList.insertBefore(
                existing.item,
                currentGalleryList.querySelector(
                  `li:nth-of-type(${newIndex + 1})`
                )
              );
              [currentItems, currentIdSet, currentIdMap] =
                snapshotCurrentMedia();
            }
          });
        }

        this.querySelector("media-gallery")?.setActiveMedia?.(
          `${this.dataset.section}-${mediaId}`,
          true
        );

        // Sync product modal media
        const currentModalContent = this.productModal?.querySelector(
          ".product-media-modal__content"
        );
        const newModalContent = parsedHtml.querySelector(
          "product-modal .product-media-modal__content"
        );
        if (currentModalContent && newModalContent) {
          currentModalContent.innerHTML = newModalContent.innerHTML;
        }

        // If no view param, replace gallery wholesale
        if (currentGalleryList && newGalleryList && view === null) {
          currentGalleryList.innerHTML = newGalleryList.innerHTML;
        }

        // Replace thumbnails
        if (currentThumbList && newThumbList) {
          currentThumbList.innerHTML = newThumbList.innerHTML;
        }

        // Reset all slider-component pagination
        const sliders = this.querySelectorAll("slider-component");
        if (sliders.length) {
          sliders.forEach((slider) => slider.resetPages());
        }

        // Re-bind gallery/thumbnail interaction
        const mediaGallery = this.querySelector("media-gallery");
        if (mediaGallery) {
          const galleryViewer = mediaGallery.querySelector(
            '[id^="GalleryViewer"]'
          );
          const galleryThumbnails = mediaGallery.querySelector(
            '[id^="GalleryThumbnails"]'
          );
          if (galleryViewer && galleryThumbnails) {
            galleryViewer.addEventListener(
              "slideChanged",
              debounce(mediaGallery.onSlideChanged.bind(mediaGallery), 500)
            );
            galleryThumbnails
              .querySelectorAll("[data-target]")
              .forEach((thumb) => {
                thumb
                  .querySelector("button")
                  .addEventListener(
                    "click",
                    mediaGallery.setActiveMedia.bind(
                      mediaGallery,
                      thumb.dataset.target,
                      false
                    )
                  );
              });
          }
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step
            ? parseInt(this.quantityInput.step)
            : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;
        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const variantId = this.productForm?.variantIdInput?.value;
        if (!variantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");

        fetch(
          `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHtml = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, parsedHtml);
          })
          .catch((error) => console.error(error))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, parsedHtml) {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();

        const quantityFormSource = parsedHtml.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];

        for (let selector of selectors) {
          const destination = this.quantityForm.querySelector(selector);
          const source = quantityFormSource.querySelector(selector);
          if (!destination || !source) continue;

          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const value = source.getAttribute(attribute);
              if (value !== null) {
                destination.setAttribute(attribute, value);
              } else {
                destination.removeAttribute(attribute);
              }
            }
          } else {
            destination.innerHTML = source.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector("product-form");
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector("pickup-availability");
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}